const moment = require('moment');

export function getDateArray(start, end, interval) {
  //daily: interval == 1
  const dateArray = [];
  let s = moment(start);
  let e = moment(end);
  while (s.isSameOrBefore(e)) {
    dateArray.push(s.format('YYYY-MM-DD'));
    s = s.add(interval, 'days');
  }
  return dateArray;
}
